import SiteTypeContainer from "components/Site/Type/SiteType.container";

const SiteTypePage = () => {
  return <SiteTypeContainer />;
};

export default SiteTypePage;
